import React, { Suspense } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import CourseDataProvider from '../../../Utils/Courses/CourseDataProvider';
import UserDataProvider from '../../../Utils/Users/UserDataProvider';
import {
  QuizCompleteContainer,
  ResultsContainer,
} from '../Completed/QuizComplete.styles';
import Auth from '../../../Helpers/auth';
import FinishedPicture from '../../../Visuals/Images/finished.svg';
import { AuthCheckUser } from '../../../Utils/AuthCheck/UserCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';
const UserIncompleteComponent = React.lazy(
  () => import('../DisplayUserInfo/DisplayUserIncompleteComponent.component')
);
const ReviewQuiz = React.lazy(
  () => import('../ReviewQuiz/ReviewQuiz.component')
);
import IncompleteButtons from '../ComIncButtons/IncompleteButtons.component';
import LoadingQuizCompletePage from '../../../Components/LoadingPages/LoadingQuizComplete.component';

const IncompleteCourse = () => {
  const { id } = useParams();
  const { data } = Auth.getProfile();
  const userId = data?.id || localStorage.getItem('temp_id');
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/user');
  };

  const retakeQuiz = () => {
    navigate(`/course/quiz/${id}`);
  };

  return (
    <Suspense fallback={<LoadingQuizCompletePage />}>
      <AuthCheckUser>
        <HelmetHelper
          title="Incompleted Course"
          description="Course incompleted, can review the quiz questions"
        />
        <QuizCompleteContainer>
          <ResultsContainer>
            <img src={FinishedPicture} alt="hexagons" />
            <Suspense fallback={<div>Loading user info...</div>}>
              <UserIncompleteComponent id={id} />
            </Suspense>
          </ResultsContainer>
          {/* The buttons */}
          <CourseDataProvider courseId={id}>
            {(course) => (
              <UserDataProvider userId={userId} courseId={id}>
                {(userInfo) => (
                  <>
                    <Suspense fallback={<div>Loading buttons...</div>}>
                      <IncompleteButtons
                        primaryFunction={retakeQuiz}
                        primarySpan="Retake Quiz"
                        secondaryFunction={goHome}
                        secondarySpan="Go Home"
                      />
                    </Suspense>

                    {/* For reviewing the quiz */}
                    <Suspense fallback={<div>Loading quiz review...</div>}>
                      <ReviewQuiz
                        course={course}
                        userAnswers={userInfo?.courses?.[0]?.userAnswers}
                        homeLink={goHome}
                      />
                    </Suspense>
                  </>
                )}
              </UserDataProvider>
            )}
          </CourseDataProvider>
        </QuizCompleteContainer>
      </AuthCheckUser>
    </Suspense>
  );
};

export default IncompleteCourse;
